import React from "react";
import { FolderItemProps } from "./FolderItem.props";
import { P } from "common/P/P";
import { ReactComponent as FolderIcon } from "common/assets/icons/folder.svg";

const FolderItem: React.FC<FolderItemProps> = ({
	name,
	files,
	quantity,
	onDoubleClick,
}) => {
	return (
		<div
			className="p-4 rounded-md cursor-pointer bg-[#F7F7F7] grid grid-cols-frMax place-content-between gap-4 w-full min-w-[330px]"
			onDoubleClick={onDoubleClick}
		>
			<div className="grid gap-4 grid-cols-maxTwo place-items-center">
				<FolderIcon />
				<P size="p3" type="medium" className="cursor-pointer">
					{name}
				</P>
			</div>
			<P
				size="p3"
				type="medium"
				className="cursor-pointer place-self-center text-grayTwo"
			>
				{quantity}
			</P>
		</div>
	);
};

export default FolderItem;
